// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"NT-z","inlineTitle":"OT-z","sponsoredAdsWrapper":"PT-z","marketplaceRecosWrapper":"QT-z"};